import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import ErrorMessage from '../components/ErrorMessage'
import LoadingProgress from '../components/LoadingProgress'

import { fetchPDA } from '../actions/pdas'
import '../styles/PDADetailsView.css'

class PDADetailsView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      
    };

  }

  componentDidMount() {
    this.props.fetchPDA(this.props.match.params.id)
  }

  render() {
    const { role, type, pda, error, loading } = this.props

    if (error) return <ErrorMessage message={error.message} />;
    if (!pda || loading) return <LoadingProgress />;

    return (
      <div className="pda-details-view">

        {/* Header */}
        <div className="pda-details-header">
          <div className="header-content">
            <div className="header-text">
              <h1>
                <i className="fas fa-mobile-alt"></i>
                <span className="text-vw-dark">PDA</span>
                <span className="text-vw-light">{pda.Code}</span>
              </h1>
            </div>
            {role === 'ADMIN' && type === 'MASTER' && (
              <div className="header-actions">
                <Link to={`/pdas/${pda._id}/edit`} className="pda-details-btn primary">
                  <i className="fas fa-edit"></i><span>Editar</span>
                </Link>
              </div>
            )}
          </div>
        </div>

        {/* Info card */}
        <div className="pda-details-card">
          <div className="pda-card-header">
            <i className="fas fa-sliders-h mr-2"></i>Información general
          </div>
          <div className="pda-card-body">
            <div className="pda-info-row">
              <span className="pda-info-label"><i className="fas fa-hashtag mr-1"></i>Código</span>
              <span className="pda-info-value">{pda.Code}</span>
            </div>
            <div className="pda-info-row">
              <span className="pda-info-label"><i className="fas fa-user mr-1"></i>Cliente</span>
              <span className="pda-info-value">{pda.Customer.Fullname}</span>
            </div>
            <div className="pda-info-row">
              <span className="pda-info-label"><i className="fas fa-fingerprint mr-1"></i>SN Dispositivo</span>
              <span className="pda-info-value token-value">{pda.Token}</span>
            </div>
          </div>
        </div>

      </div>
    )
  }
}

const mapStateToProps = state => ({
  pda: state.pdas.pda,
  loading: state.pdas.loading,
  error: state.pdas.error,
  role: state.auth.role,
  type: state.auth.type
})

const mapDispatchToProps = dispatch => ({
  fetchPDA: bindActionCreators(fetchPDA, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(PDADetailsView)
